import { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";
import axios from "../../utils/axiosInstance";

const Statistic = () => {
  const [salesData, setSalesData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [stats, setStats] = useState({
    users: 0,
    orders: 0,
    products: 0,
    revenue: 0,
  });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get("/statistics");
        console.log("static",response.data);
        setStats({
          users: response.data.users,
          orders: response.data.ordersCount,
          products: response.data.products,
          revenue: response.data.revenue,
        });
        setSalesData(response.data.salesData || []);
        setCategoryData(response.data.categoryData || []);
      } catch (error) {
        console.error("Error fetching statistics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) return <p>Loading...</p>;
  const COLORS = ["#0d6efd", "#198754", "#ffc107", "#dc3545","#8800CC"];

  return (
    <div className="container my-4">
      <h2 className="m-4">Statistic</h2>
      {/* Cards */}
      <div className="row g-3 mb-4">
        <div className="col-6 col-md-3">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h6 className="text-muted">Orders</h6>
              <h4 className="fw-bold">{stats.orders}</h4>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h6 className="text-muted">Revenue</h6>
              <h4 className="fw-bold">${stats.revenue}</h4>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h6 className="text-muted">Customers</h6>
              <h4 className="fw-bold">{stats.users}</h4>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h6 className="text-muted">Products</h6>
              <h4 className="fw-bold">{stats.products}</h4>
            </div>
          </div>
        </div>
      </div>

      {/* Charts */}
      <div className="row g-4">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6 className="mb-3">Monthly Sales</h6>
              <div style={{ width: "100%", height: 250 }}>
                <ResponsiveContainer>
                  <LineChart data={salesData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="sales"
                      stroke="#0d6efd"
                      strokeWidth={3}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6 className="mb-3">Sales by Category</h6>
              <div style={{ width: "100%", height: 250 }}>
                <ResponsiveContainer>
                  <PieChart>
                    <Pie
                      data={categoryData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      outerRadius={80}
                      label
                    >
                      {categoryData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistic;
